<p class="tw-p-2" data-cy="info-popover">
  <span class="tw-text-[13px]" data-cy="jockey-info">
    <span class="tw-font-bold">Jockey:</span> {{ receivedData.Jockey }}
  </span>
  <br>
  <span class="tw-text-[13px]" data-cy="trainer-info">
    <span class="tw-font-bold">Trainer:</span> {{ receivedData.Trainer }}
  </span>
  <br>
  <span class="tw-text-[13px]" data-cy="owner-info">
    <span class="tw-font-bold">Owner:</span> {{ receivedData.Owner }}
  </span>
  <br>
  <span class="tw-text-[13px]" data-cy="weight-info">
    <span class="tw-font-bold">Weight:</span> {{ receivedData.Weight | horseWeight }}
  </span>
</p>
